import { render, staticRenderFns } from "./addReminder.vue?vue&type=template&id=ceaf889e&"
import script from "./addReminder.vue?vue&type=script&lang=js&"
export * from "./addReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports